import React, { useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "react-confirm-alert/src/react-confirm-alert.css";
// import { useDispatch } from 'react-redux'
import { RxHamburgerMenu } from "react-icons/rx";
import { LuFullscreen } from "react-icons/lu";
// Icons
import {
  MdDashboard,
  MdOutlineMovieCreation,
  // MdMenu,
  MdClose,
} from "react-icons/md";
import {
  FaUserFriends,
  FaSchool,
  FaLanguage,
  FaHeadphones,
  FaThLarge,
} from "react-icons/fa";
import { RiProfileFill, RiLockPasswordFill } from "react-icons/ri";
import { PiProjectorScreen } from "react-icons/pi";
import { BsCalendar3Event } from "react-icons/bs";
import { LiaDonateSolid } from "react-icons/lia";
import { IoIosNotificationsOutline } from "react-icons/io";
import { AiTwotoneAudio } from "react-icons/ai";

const Sidebar = () => {
  const location = useLocation();
  const [navbarOpen, setNavbarOpen] = useState(false);

  const navItemClass = `flex items-center font-bold hover:bg-[#e3ebf7] 
    text-[#212121] px-5 py-3 rounded gap-4 transition-colors duration-200`;

  const menuItems = useMemo(
    () => [
      { path: "/app/dashboard", icon: <MdDashboard />, label: "Dashboard" },
      {
        path: "/app/user-management",
        icon: <FaUserFriends />,
        label: "User Management",
      },
      {
        path: "/app/reportScreening",
        icon: <MdOutlineMovieCreation />,
        label: "Screening Report",
      },      
      // {
      //   path: '/app/studentManagement',
      //   icon: <FaUserFriends />,
      //   label: 'Student Management'
      // },
      {
        path: "/app/lanugageManagement",
        icon: <FaLanguage className="text-2xl" />,
        label: "Language Management",
      },
      { path: "/app/question", icon: <BsCalendar3Event />, label: "Questions" },
      {path: "/app/splashScreen",icon: <LuFullscreen />,label: "Question Splash Screen"},

      // {
      //   path: "/app/countryLanguageManagement",
      //   icon: <FaLanguage className="text-2xl" />,
      //   label: "Country Language",
      // },

      {
        path: "/app/FirstScreen",
        icon: <PiProjectorScreen />,
        label: "First Screen",
      },
      {
        path: "/app/introduction",
        icon: <RiProfileFill />,
        label: "Introduction",
      },
      {
        path: "/app/StaticAudio",
        icon: <AiTwotoneAudio />,
        label: "Audio Files",
      },
      {
        path: "/app/service",
        icon: <MdOutlineMovieCreation />,
        label: "Orkids Service",
      },
      {
        path: "/app/languageSetting",
        icon: <MdOutlineMovieCreation />,
        label: "Translation Management",
      },
     {
        path: "/app/CategoryManagement",
        icon: <FaThLarge />,
        label: "Translation Category",
      },
      // {
      //   path: "/app/loginHistory",
      //   icon: <MdManageAccounts />,
      //   label: "Login History",
      // },
      // {
      //   path: "/app/reportManagement",
      //   icon: <PiChatsBold />,
      //   label: "Report Management",
      // },
      {
        path: "/app/CourseManagement",
        icon: <FaSchool />,
        label: "Course Management",
      },

      {
        path: "/app/notification",
        icon: <IoIosNotificationsOutline />,
        label: "Notification",
      },
      { path: "/app/donate", icon: <LiaDonateSolid />, label: "Donate" },
      { path: "/app/help", icon: <FaHeadphones />, label: "Help" },
      {
        path: "/app/update-Password",
        icon: <RiLockPasswordFill />,
        label: "Update Password",
      },
    ],
    []
  );
  // const navigate = useNavigate();
  // const logoutConfirmed = () => {
  //   dispatch(logout());
  //   showSuccessToast("You have logged out successfully!");
  //   navigate('/login');
  // };

  // const handleLogOut = () => {
  //   confirmAlert({
  //     title: 'Confirm Logout',
  //     message: 'Are you sure you want to logout?',
  //     buttons: [
  //       { label: 'Yes', onClick:logoutConfirmed },
  //       { label: 'No' }
  //     ]
  //   })
  // }

  const isActive = (path) =>
    location.pathname === path ||
    (path !== "/app/dashboard" && location.pathname.startsWith(path));

  return (
    <>
      {/* Toggle Button for Small Screens */}
      <button
        className={`${navbarOpen ? "hidden" : "flex"
          } fixed top-0 left-0 px-5 items-center justify-center 
          border-r border-gray-200 text-gray-500 focus:outline-none 
          focus:bg-gray-800 z-50 h-16 xl:hidden`}
        onClick={() => setNavbarOpen(true)}
        aria-label="Open Sidebar Menu"
      >
        <RxHamburgerMenu className="text-xl text-black" />
      </button>

      {/* Sidebar Container */}
      <div
        style={{ fontFamily: "Roboto Condensed" }}
        className={`${!navbarOpen ? "hidden" : "flex"
          } fixed h-screen left-0 inset-y-0 xl:static xl:flex 
          w-72 z-50 flex-col bg-[#F7F7F7]`}
      >
        {/* Header for Mobile */}
        <div className="relative flex items-center w-72 p-3 xl:hidden">
          <div className="flex items-center justify-center">
            <img
              src="/icons8-system-administrator-female-100.png"
              alt="Admin Avatar"
              className="rounded-full mr-4"
              width={30}
            />
            <span className="text-2xl font-bold">Orkids</span>
          </div>
          <button
            onClick={() => setNavbarOpen(false)}
            className="absolute right-4 border rounded-full z-50 block xl:hidden  p-1 text-gray-600 transition-colors duration-200"
            aria-label="Close Sidebar Menu"
          >
            <MdClose size={20} />
          </button>
        </div>

        {/* Navigation Items */}
        <nav className="overflow-y-auto h-[93vh]    space-y-1 flex flex-col w-full px-3 py-2 [&::-webkit-scrollbar]:w-1">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`${navItemClass} ${isActive(item.path) ? "bg-[#e3ebf7]" : ""
                }`}
              onClick={() => setNavbarOpen(false)}
              aria-label={`Go to ${item.label}`}
            >
              <span className="text-[#8E8E93] text-xl">{item.icon}</span>
              <span className="text-[#000000]/90 sidebar-font">
                {item.label}
              </span>
            </Link>
          ))}

          {/* <button
            onClick={handleLogOut}
            className={`${navItemClass} text-left`}
            aria-label='Logout from the system'
          >
            <IoMdLogOut className='text-[#8E8E93] text-xl' />
            Logout
          </button> */}
        </nav>
      </div>
    </>
  );
};

export default React.memo(Sidebar);
